import styled, { keyframes } from 'styled-components'
import { cores } from '../../styles'

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top: 4px solid ${cores.corPrincipal};
  border-radius: 50%;
  animation: ${spin} 1.5s linear infinite;
  margin: auto;
`
